module.exports = __webpack_public_path__ + "static/p3-d8c6fe635783f651cad90f116b2fc7e1.jpg";